// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"650":"b6b20dba6899fedc","888":"e6da11d07b616ca4"}[chunkId] + ".css";
};